
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface OnboardingNavigationProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  canProceed: boolean;
  isTransitioning: boolean;
  onBack: () => void;
  onNext: () => void;
}

const OnboardingNavigation = ({
  isFirstStep,
  isLastStep,
  canProceed,
  isTransitioning,
  onBack,
  onNext
}: OnboardingNavigationProps) => {
  return (
    <div className="flex gap-4 animate-slide-up">
      <Button
        onClick={onBack}
        disabled={isTransitioning}
        variant="outline"
        className="flex-1 bg-white/20 border-white/30 text-white hover:bg-white/30 py-3 rounded-xl font-bold transition-all duration-300 hover:scale-105 disabled:opacity-50"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        {isFirstStep ? 'Back to Landing' : 'Previous'}
      </Button>
      
      <Button
        onClick={onNext}
        disabled={!canProceed || isTransitioning}
        className={`flex-1 py-3 rounded-xl font-black transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed ${
          canProceed && !isTransitioning 
            ? 'bg-gradient-to-r from-purple-600 to-teal-500 hover:from-purple-700 hover:to-teal-600 text-white animate-glow' 
            : 'bg-gray-300 text-gray-500'
        }`}
      >
        {isTransitioning ? (
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
        ) : (
          <>
            {isLastStep ? 'Complete Signup' : 'Next'}
            <ArrowRight className="w-4 h-4 ml-2" />
          </>
        )}
      </Button>
    </div>
  );
};

export default OnboardingNavigation;
